import request from '../utils/request'

export function loginByEmail(student_email, opt_code) {
    return request.post("./index.php", {
        function: "loginByEmail",
        student_email,
        opt_code
    });
}

export function createLoginOPT(student_email, turnstile_token) {
    return request.post("./index.php", {
        function: "createLoginOPT",
        student_email,
        ...(turnstile_token && { turnstile_token }),
    });
}

export function postRequest(functionName, params) {
    return request.post("./index.php", {
        function: functionName,
        ...params
    });
}


export function postRequestAISG(functionName, params) {
    return request.post("/AIChat/index.php", {
        function: functionName,
        ...params
    });
}


export function postAiffectRequest(functionName, params) {
    return request.post("/Aiffect/index.php", {
        function: functionName,
        ...params
    });
}

///KNOWIT AI

export function getUserConversationListRecentTen(params) {
    return request.post('/index.php', {
        function: 'getUserConversationListRecentTen',
        ...params
    })
}
export function updateConversation(params) {
    return request.post('/index.php', {
        function: 'updateConversation2',
        ...params
    })
}
export function removeConversation(params) {
    return request.post('/index.php', {
        function: 'removeConversation',
        ...params
    })
}
export function changeConversationName(params) {
    return request.post('/index.php', {
        function: 'changeConversationName',
        ...params
    })
}

export function searchPublicPosts(params) {
    return request.post('/index.php', {
        function: 'searchPublicPosts',
        ...params
    })
}

export function getMyMessage(params) {
    return request.post('/index.php', {
        function: 'getMyMessage',
        ...params
    })
}

// Card API Functions
export function updateCard(params) {
    return request.post('/index.php', {
        function: 'updateCard',
        ...params
    })
}

// Guide AI Dialogue API Functions
export function createDialogue(params) {
    return request.post('/index.php', {
        function: 'createDialogue',
        ...params
    })
}

export function getDialogue(params) {
    return request.post('/index.php', {
        function: 'getDialogue',
        ...params
    })
}

export function updateDialogue(params) {
    return request.post('/index.php', {
        function: 'updateDialogue',
        ...params
    })
}

export function getDialogueCards(params) {
    return request.post('/index.php', {
        function: 'getDialogueCards',
        ...params
    })
}

// Card Reminder API Functions
export function createCardReminderSchedule(params) {
    return request.post('/index.php', {
        function: 'createCardReminderSchedule',
        ...params
    })
}

// Coder Todos API Functions
export function getMyAITasks(params) {
    return request.post('/index.php', {
        function: 'getMyAITasks',
        ...params
    })
}

export function updateCoderTodo(params) {
    return request.post('/index.php', {
        function: 'updateCoderTodo',
        ...params
    })
}

export function deleteCoderTodo(params) {
    return request.post('/index.php', {
        function: 'deleteCoderTodo',
        ...params
    })
}

export function updateCardReminderSchedule(params) {
    return request.post('/index.php', {
        function: 'updateCardReminderSchedule',
        ...params
    })
}

export function deleteCardReminderSchedule(params) {
    return request.post('/index.php', {
        function: 'deleteCardReminderSchedule',
        ...params
    })
}

export function getCardReminderSchedule(params) {
    return request.post('/index.php', {
        function: 'getCardReminderSchedule',
        ...params
    })
}

export function getUserActiveReminders(params) {
    return request.post('/index.php', {
        function: 'getUserActiveReminders',
        ...params
    })
}


export function sendConversation(params) {
    return request.post('AIChat/index.php', {
        function: 'sendConversation',
        ...params
    })
}

